const asBool = (value: string | undefined): boolean => value === 'true';

export type ConfigState = {
    backend: {
        AUTHENTICATION_SERVICE: string | undefined;
        MENU_SERVICE: string | undefined;
    };
    driverAdministrationApi: string | undefined;
    orderCommunicationBookingApi: string | undefined;
    orderCommunicationFmsUrl: string;
    homeRoute: string | undefined;
    id: string | undefined;
    login: {
        authority: string | undefined;
        clientId: string | undefined;
        oauthScope: string[];
        mockAuthorization: boolean;
        mockLocale: string | undefined;
        mockTenant: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
    };
    serviceEnvironment: string;
    enableMockServer: boolean;
    mockSelectedAssetId: string | undefined;
    logoutUri: string | undefined;
    sentryToken: string | undefined;
    sentryModuleName: string;
};

export const config: ConfigState = {
    backend: {
        AUTHENTICATION_SERVICE: import.meta.env.VITE_AUTHENTICATION_SERVICE,
        MENU_SERVICE: import.meta.env.VITE_MENU_SERVICE,
    },
    driverAdministrationApi: import.meta.env.VITE_DRIVER_ADMINISTRATION_API,
    orderCommunicationBookingApi: import.meta.env.VITE_ORDER_COMMUNICATION_BOOKING_API,
    orderCommunicationFmsUrl:
        import.meta.env.VITE_ORDER_COMMUNICATION_FMS_URL ?? 'https://ordercom.cartright.rio.cloud',
    homeRoute: import.meta.env.VITE_HOME_ROUTE,
    id: import.meta.env.VITE_ID,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
        oauthScope: [
            'order-communication-web.read',
            'ordercom-cartright.read',
            'order-communication-booking.read',
            'drivers.read',
            'openid',
            'profile',
            'email',
        ],
        mockAuthorization: import.meta.env.DEV,
        mockLocale: import.meta.env.VITE_LOGIN_MOCK_LOCALE,
        mockTenant: import.meta.env.VITE_LOGIN_MOCK_TENANT,
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
    },
    serviceEnvironment: import.meta.env.MODE,
    enableMockServer: import.meta.env.DEV,
    mockSelectedAssetId: import.meta.env.VITE_MOCK_SELECTED_ASSET_ID,
    logoutUri: import.meta.env.VITE_LOGOUT_URI,
    sentryToken: import.meta.env.VITE_SENTRY_DSN,
    sentryModuleName: 'order-communication-web',
};
